/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/payment';
import '../common/currency';
import '../connect/v2/resources/card';
import './unsuccessful_payments';
import './transaction_status_report';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentreporter": {
        "nested": {
          "service": {
            "nested": {
              "ListTransactionFeeTaxReportsRequest": {
                "fields": {
                  "unitTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ListTransactionFeeTaxReportsResponse": {
                "fields": {
                  "reports": {
                    "type": ".squareup.paymentreporter.service.ListTransactionFeeTaxReportsResponse.TransactionFeeTaxReport",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TransactionFeeTaxReport": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "reportYear": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "reportMonth": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "reportId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PaymentMethodsAvailableFiltersRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "filterByType": {
                    "type": ".squareup.paymentreporter.service.FilterByType",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "PaymentMethodsAvailableFiltersResponse": {
                "fields": {
                  "filterTypes": {
                    "type": ".squareup.paymentreporter.service.FilterByType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "filterValues": {
                    "type": ".squareup.paymentreporter.service.FilterByValue",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaymentMethodsSummaryReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reportingHours": {
                    "type": ".squareup.paymentreporter.service.ZonedTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.paymentreporter.service.FilterByValue",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "groupByType": {
                    "type": ".squareup.paymentreporter.service.GroupByType",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "timelinePeriod": {
                    "type": ".squareup.paymentreporter.service.TimelinePeriod",
                    "id": 8,
                    "rule": "optional"
                  },
                  "requestFlags": {
                    "type": ".squareup.paymentreporter.service.PaymentMethodsSummaryReportRequest.RequestFlags",
                    "id": 9,
                    "rule": "optional"
                  },
                  "weeklyStartDay": {
                    "type": ".squareup.common.time.DayOfWeek",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RequestFlags": {
                    "fields": {
                      "includeOnlyPendingPayments": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "includeExternalSourceBreakdown": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "fillEmptyBuckets": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "clampBuckets": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "TimelinePeriod": {
                "values": {
                  "TIMELINE_PERIOD_DO_NOT_USE": 0,
                  "NONE": 1,
                  "DAILY": 2,
                  "WEEKLY": 3,
                  "MONTHLY": 4
                }
              },
              "ZonedTimeInterval": {
                "fields": {
                  "start": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "end": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Employee": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employeeToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Device": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deviceNickname": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Location": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaymentMethod": {
                "values": {
                  "PAYMENT_METHOD_DO_NOT_USE": 0,
                  "CASH": 1,
                  "CARD": 2,
                  "OTHER": 3,
                  "SPLIT_TENDER": 4,
                  "THIRD_PARTY_CARD": 5,
                  "SQUARE_GIFT_CARD": 6,
                  "ZERO_AMOUNT": 7,
                  "EXTERNAL": 8,
                  "INSTALLMENT": 9,
                  "EMONEY": 10,
                  "CASH_APP": 11,
                  "BANK_TRANSFER": 12,
                  "FOOD_VOUCHER": 13,
                  "AFTERPAY": 14,
                  "PAYPAY": 15,
                  "CHECK": 16,
                  "SQUARE_ACCOUNT_BALANCE": 17,
                  "NO_SALE": 18,
                  "RAKUTEN_PAY": 19,
                  "AU_PAY": 20,
                  "D_BARAI": 21,
                  "MERPAY": 22,
                  "WECHAT_PAY": 23,
                  "ALIPAY": 24,
                  "TRUSTED_EXTERNAL_PARTNER": 25,
                  "BITCOIN": 26,
                  "BALANCE_TRANSACTION": 27,
                  "PUSH_CARD": 28,
                  "SQUARE_CAPITAL": 29,
                  "THIRD_PARTY_FEE": 30,
                  "THIRD_PARTY_FEE_REVERSAL": 31,
                  "CARD_VERIFICATION": 32,
                  "SNAP": 33,
                  "EBT_CASH": 34,
                  "STORED_VALUE": 35,
                  "LOCAL_CASH": 36
                }
              },
              "FilterByType": {
                "values": {
                  "FILTER_BY_TYPE_DO_NOT_USE": 0,
                  "FILTER_BY_TYPE_NONE": 1,
                  "DEVICE_FILTER": 2,
                  "DEVICE_NICKNAME_FILTER": 3,
                  "LOCATION_FILTER": 4,
                  "EMPLOYEE_FILTER": 5,
                  "PAYMENT_METHOD_FILTER": 6,
                  "SQUARE_PRODUCT_FILTER": 7,
                  "ORDER_SOURCE_FILTER": 8
                }
              },
              "FilterByValue": {
                "fields": {
                  "employees": {
                    "type": ".squareup.paymentreporter.service.Employee",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "devices": {
                    "type": ".squareup.paymentreporter.service.Device",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "paymentMethods": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "squareProducts": {
                    "type": ".squareup.common.payment.SquareProduct",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "deviceNicknames": {
                    "type": ".squareup.paymentreporter.service.Device",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "orderSource": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "GroupByType": {
                "values": {
                  "GROUP_BY_TYPE_DO_NOT_USE": 0,
                  "GROUP_BY_TYPE_NONE": 1,
                  "DEVICE": 2,
                  "DEVICE_NICKNAME": 3,
                  "LOCATION": 4,
                  "EMPLOYEE": 5,
                  "PAYMENT_METHOD": 6,
                  "ENTRY_METHOD": 7,
                  "CARD_BRAND": 8,
                  "CARD_TYPE": 9,
                  "SQUARE_PRODUCT": 10,
                  "EXTERNAL_PAYMENT": 11,
                  "CARD_ORIGIN": 12
                }
              },
              "PaymentMethodsSummaryReportResponse": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reportingHours": {
                    "type": ".squareup.paymentreporter.service.ZonedTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timelinePeriod": {
                    "type": ".squareup.paymentreporter.service.TimelinePeriod",
                    "id": 5,
                    "rule": "optional"
                  },
                  "aggregationGroupings": {
                    "type": ".squareup.paymentreporter.service.AggregationGrouping",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "filters": {
                    "type": ".squareup.paymentreporter.service.FilterByValue",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "numPendingPayments": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "AggregationGrouping": {
                "fields": {
                  "groupByTypes": {
                    "type": ".squareup.paymentreporter.service.GroupByType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "lineItemData": {
                    "type": ".squareup.paymentreporter.service.AggregationGrouping.LineItemData",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "totalLineItemData": {
                    "type": ".squareup.paymentreporter.service.AggregationGrouping.LineItemData",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "LineItemData": {
                    "fields": {
                      "groupingKey": {
                        "type": ".squareup.paymentreporter.service.GroupingKey",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subGrouping": {
                        "type": ".squareup.paymentreporter.service.GroupByType",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "numPayments": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      },
                      "numRefunds": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      },
                      "paymentAmount": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "refundAmount": {
                        "type": ".squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "totalCollected": {
                        "type": ".squareup.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "fees": {
                        "type": ".squareup.common.Money",
                        "id": 8,
                        "rule": "optional"
                      },
                      "tips": {
                        "type": ".squareup.common.Money",
                        "id": 9,
                        "rule": "optional"
                      },
                      "netTotal": {
                        "type": ".squareup.common.Money",
                        "id": 10,
                        "rule": "optional"
                      },
                      "numPendingRefunds": {
                        "type": "int64",
                        "id": 11,
                        "rule": "optional"
                      },
                      "pendingRefundAmount": {
                        "type": ".squareup.common.Money",
                        "id": 12,
                        "rule": "optional"
                      },
                      "netTotalMinusPendingRefund": {
                        "type": ".squareup.common.Money",
                        "id": 13,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GroupingKey": {
                "fields": {
                  "device": {
                    "type": ".squareup.paymentreporter.service.Device",
                    "id": 1,
                    "rule": "optional"
                  },
                  "location": {
                    "type": ".squareup.paymentreporter.service.Location",
                    "id": 2,
                    "rule": "optional"
                  },
                  "employee": {
                    "type": ".squareup.paymentreporter.service.Employee",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 4,
                    "rule": "optional"
                  },
                  "entryMethodDetails": {
                    "type": ".squareup.paymentreporter.service.GroupingKey.EntryMethodDetails",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardTypeDetails": {
                    "type": ".squareup.paymentreporter.service.GroupingKey.CardTypeDetails",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardBrandDetails": {
                    "type": ".squareup.paymentreporter.service.GroupingKey.CardBrandDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "externalPaymentDetails": {
                    "type": ".squareup.paymentreporter.service.GroupingKey.ExternalPaymentDetails",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardOriginDetails": {
                    "type": ".squareup.paymentreporter.service.GroupingKey.CardOriginDetails",
                    "id": 10,
                    "rule": "optional"
                  },
                  "dataPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardBrandDetails": {
                    "fields": {
                      "paymentReporterCardBrand": {
                        "type": ".squareup.paymentreporter.service.GroupingKey.CardBrand",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "EntryMethodDetails": {
                    "fields": {
                      "commonEntryMethod": {
                        "type": ".squareup.common.payment.EntryMethod",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CardTypeDetails": {
                    "fields": {
                      "connectV2CardType": {
                        "type": ".squareup.connect.v2.resources.Card.Type",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ExternalPaymentDetails": {
                    "fields": {
                      "externalPaymentSource": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CardOriginDetails": {
                    "fields": {
                      "cardOrigin": {
                        "type": ".squareup.paymentreporter.service.GroupingKey.CardOrigin",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CardOrigin": {
                    "values": {
                      "CARD_ORIGIN_DO_NOT_USE": 0,
                      "DOMESTIC": 1,
                      "INTERNATIONAL": 2
                    }
                  },
                  "CardBrand": {
                    "values": {
                      "CARD_BRAND_DO_NOT_USE": 0,
                      "AFTERPAY": 1,
                      "ALIPAY": 2,
                      "AMERICAN_EXPRESS": 3,
                      "BALANCE": 4,
                      "CASH_APP": 5,
                      "CHINA_UNIONPAY": 6,
                      "DISCOVER": 7,
                      "DISCOVER_DINERS": 8,
                      "EBT": 9,
                      "EFTPOS": 10,
                      "FELICA": 11,
                      "INTERAC": 12,
                      "JCB": 13,
                      "MASTERCARD": 14,
                      "OTHER_BRAND": 15,
                      "PAYPAY": 16,
                      "SQUARE_ACCOUNT_BALANCE": 17,
                      "SQUARE_CAPITAL_CARD": 18,
                      "SQUARE_GIFT_CARD": 19,
                      "VISA": 20,
                      "AU_PAY": 21,
                      "MERPAY": 22,
                      "RAKUTEN_PAY": 23,
                      "D_BARAI": 24,
                      "WECHAT_PAY": 25
                    }
                  }
                }
              },
              "PaymentReporterExternalEndpointsService": {
                "methods": {
                  "UnsuccessfulPaymentsReport": {
                    "requestType": ".squareup.paymentreporter.service.UnsuccessfulPaymentsReportRequest",
                    "responseType": ".squareup.paymentreporter.service.UnsuccessfulPaymentsReportResponse"
                  },
                  "ListTransactionFeeTaxReports": {
                    "requestType": ".squareup.paymentreporter.service.ListTransactionFeeTaxReportsRequest",
                    "responseType": ".squareup.paymentreporter.service.ListTransactionFeeTaxReportsResponse"
                  },
                  "TransactionStatusReport": {
                    "requestType": ".squareup.paymentreporter.service.TransactionStatusReportRequest",
                    "responseType": ".squareup.paymentreporter.service.TransactionStatusReportResponse"
                  }
                }
              },
              "PaymentMethodsExternalEndpointsService": {
                "methods": {
                  "GetPaymentMethodsSummaryReport": {
                    "requestType": ".squareup.paymentreporter.service.PaymentMethodsSummaryReportRequest",
                    "responseType": ".squareup.paymentreporter.service.PaymentMethodsSummaryReportResponse"
                  },
                  "GetAvailableFilters": {
                    "requestType": ".squareup.paymentreporter.service.PaymentMethodsAvailableFiltersRequest",
                    "responseType": ".squareup.paymentreporter.service.PaymentMethodsAvailableFiltersResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.ListTransactionFeeTaxReportsRequest && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.ListTransactionFeeTaxReportsResponse && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.ListTransactionFeeTaxReportsResponse?.nested?.TransactionFeeTaxReport && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsAvailableFiltersRequest && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsAvailableFiltersResponse && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsSummaryReportRequest && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsSummaryReportRequest?.nested?.RequestFlags && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.TimelinePeriod && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.ZonedTimeInterval && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.Employee && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.Device && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.Location && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethod && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.FilterByType && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.FilterByValue && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupByType && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsSummaryReportResponse && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.AggregationGrouping && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.AggregationGrouping?.nested?.LineItemData && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.CardBrandDetails && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.EntryMethodDetails && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.CardTypeDetails && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.ExternalPaymentDetails && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.CardOriginDetails && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.CardOrigin && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.GroupingKey?.nested?.CardBrand && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentReporterExternalEndpointsService && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.PaymentMethodsExternalEndpointsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListTransactionFeeTaxReportsRequest @ squareup/paymentreporter/service.proto at 182:1
 */
export const ListTransactionFeeTaxReportsRequest = $root.lookupType('squareup.paymentreporter.service.ListTransactionFeeTaxReportsRequest');
fixType(ListTransactionFeeTaxReportsRequest, {
  unitTokens: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListTransactionFeeTaxReportsRequest);
/**
 * SOURCE ListTransactionFeeTaxReportsResponse @ squareup/paymentreporter/service.proto at 186:1
 */
export const ListTransactionFeeTaxReportsResponse = $root.lookupType('squareup.paymentreporter.service.ListTransactionFeeTaxReportsResponse');
fixType(ListTransactionFeeTaxReportsResponse);
Builder.createAndAttachToType(ListTransactionFeeTaxReportsResponse);
/**
 * SOURCE TransactionFeeTaxReport @ squareup/paymentreporter/service.proto at 187:3
 */
ListTransactionFeeTaxReportsResponse.TransactionFeeTaxReport = $root.lookupType('squareup.paymentreporter.service.ListTransactionFeeTaxReportsResponse.TransactionFeeTaxReport');
fixType(ListTransactionFeeTaxReportsResponse.TransactionFeeTaxReport);
Builder.createAndAttachToType(ListTransactionFeeTaxReportsResponse.TransactionFeeTaxReport);
/**
 * SOURCE PaymentMethodsAvailableFiltersRequest @ squareup/paymentreporter/service.proto at 302:1
 */
export const PaymentMethodsAvailableFiltersRequest = $root.lookupType('squareup.paymentreporter.service.PaymentMethodsAvailableFiltersRequest');
fixType(PaymentMethodsAvailableFiltersRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  },
  timeZone: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PaymentMethodsAvailableFiltersRequest);
/**
 * SOURCE PaymentMethodsAvailableFiltersResponse @ squareup/paymentreporter/service.proto at 323:1
 */
export const PaymentMethodsAvailableFiltersResponse = $root.lookupType('squareup.paymentreporter.service.PaymentMethodsAvailableFiltersResponse');
fixType(PaymentMethodsAvailableFiltersResponse);
Builder.createAndAttachToType(PaymentMethodsAvailableFiltersResponse);
/**
 * SOURCE PaymentMethodsSummaryReportRequest @ squareup/paymentreporter/service.proto at 335:1
 */
export const PaymentMethodsSummaryReportRequest = $root.lookupType('squareup.paymentreporter.service.PaymentMethodsSummaryReportRequest');
fixType(PaymentMethodsSummaryReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  },
  timeZone: {
    notEmpty: true
  },
  timelinePeriod: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentMethodsSummaryReportRequest);
/**
 * SOURCE RequestFlags @ squareup/paymentreporter/service.proto at 368:3
 */
PaymentMethodsSummaryReportRequest.RequestFlags = $root.lookupType('squareup.paymentreporter.service.PaymentMethodsSummaryReportRequest.RequestFlags');
fixType(PaymentMethodsSummaryReportRequest.RequestFlags);
Builder.createAndAttachToType(PaymentMethodsSummaryReportRequest.RequestFlags);
/**
 * SOURCE TimelinePeriod @ squareup/paymentreporter/service.proto at 393:1
 */
export const TimelinePeriod = $root.lookupEnum('squareup.paymentreporter.service.TimelinePeriod').values;
/**
 * SOURCE ZonedTimeInterval @ squareup/paymentreporter/service.proto at 401:1
 */
export const ZonedTimeInterval = $root.lookupType('squareup.paymentreporter.service.ZonedTimeInterval');
fixType(ZonedTimeInterval, {
  start: {
    required: true
  },
  end: {
    required: true
  },
  timeZone: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ZonedTimeInterval);
/**
 * SOURCE Employee @ squareup/paymentreporter/service.proto at 413:1
 */
export const Employee = $root.lookupType('squareup.paymentreporter.service.Employee');
fixType(Employee);
Builder.createAndAttachToType(Employee);
/**
 * SOURCE Device @ squareup/paymentreporter/service.proto at 420:1
 */
export const Device = $root.lookupType('squareup.paymentreporter.service.Device');
fixType(Device);
Builder.createAndAttachToType(Device);
/**
 * SOURCE Location @ squareup/paymentreporter/service.proto at 435:1
 */
export const Location = $root.lookupType('squareup.paymentreporter.service.Location');
fixType(Location);
Builder.createAndAttachToType(Location);
/**
 * SOURCE PaymentMethod @ squareup/paymentreporter/service.proto at 440:1
 */
export const PaymentMethod = $root.lookupEnum('squareup.paymentreporter.service.PaymentMethod').values;
/**
 * SOURCE FilterByType @ squareup/paymentreporter/service.proto at 516:1
 */
export const FilterByType = $root.lookupEnum('squareup.paymentreporter.service.FilterByType').values;
/**
 * SOURCE FilterByValue @ squareup/paymentreporter/service.proto at 528:1
 */
export const FilterByValue = $root.lookupType('squareup.paymentreporter.service.FilterByValue');
fixType(FilterByValue);
Builder.createAndAttachToType(FilterByValue);
/**
 * SOURCE GroupByType @ squareup/paymentreporter/service.proto at 537:1
 */
export const GroupByType = $root.lookupEnum('squareup.paymentreporter.service.GroupByType').values;
/**
 * SOURCE PaymentMethodsSummaryReportResponse @ squareup/paymentreporter/service.proto at 553:1
 */
export const PaymentMethodsSummaryReportResponse = $root.lookupType('squareup.paymentreporter.service.PaymentMethodsSummaryReportResponse');
fixType(PaymentMethodsSummaryReportResponse, {
  merchantToken: {
    required: true
  },
  reportingPeriod: {
    required: true
  },
  timelinePeriod: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentMethodsSummaryReportResponse);
/**
 * SOURCE AggregationGrouping @ squareup/paymentreporter/service.proto at 573:1
 */
export const AggregationGrouping = $root.lookupType('squareup.paymentreporter.service.AggregationGrouping');
fixType(AggregationGrouping);
Builder.createAndAttachToType(AggregationGrouping);
/**
 * Represents a row where the GROUP_BY_PERIOD is NONE, otherwise represents a cell in the table
 *
 * SOURCE LineItemData @ squareup/paymentreporter/service.proto at 600:3
 */
AggregationGrouping.LineItemData = $root.lookupType('squareup.paymentreporter.service.AggregationGrouping.LineItemData');
fixType(AggregationGrouping.LineItemData);
Builder.createAndAttachToType(AggregationGrouping.LineItemData);
/**
 * SOURCE GroupingKey @ squareup/paymentreporter/service.proto at 631:1
 */
export const GroupingKey = $root.lookupType('squareup.paymentreporter.service.GroupingKey');
fixType(GroupingKey);
Builder.createAndAttachToType(GroupingKey);
/**
 * SOURCE CardBrandDetails @ squareup/paymentreporter/service.proto at 646:3
 */
GroupingKey.CardBrandDetails = $root.lookupType('squareup.paymentreporter.service.GroupingKey.CardBrandDetails');
fixType(GroupingKey.CardBrandDetails);
Builder.createAndAttachToType(GroupingKey.CardBrandDetails);
/**
 * SOURCE EntryMethodDetails @ squareup/paymentreporter/service.proto at 650:3
 */
GroupingKey.EntryMethodDetails = $root.lookupType('squareup.paymentreporter.service.GroupingKey.EntryMethodDetails');
fixType(GroupingKey.EntryMethodDetails);
Builder.createAndAttachToType(GroupingKey.EntryMethodDetails);
/**
 * SOURCE CardTypeDetails @ squareup/paymentreporter/service.proto at 654:3
 */
GroupingKey.CardTypeDetails = $root.lookupType('squareup.paymentreporter.service.GroupingKey.CardTypeDetails');
fixType(GroupingKey.CardTypeDetails);
Builder.createAndAttachToType(GroupingKey.CardTypeDetails);
/**
 * SOURCE ExternalPaymentDetails @ squareup/paymentreporter/service.proto at 658:3
 */
GroupingKey.ExternalPaymentDetails = $root.lookupType('squareup.paymentreporter.service.GroupingKey.ExternalPaymentDetails');
fixType(GroupingKey.ExternalPaymentDetails);
Builder.createAndAttachToType(GroupingKey.ExternalPaymentDetails);
/**
 * SOURCE CardOriginDetails @ squareup/paymentreporter/service.proto at 662:3
 */
GroupingKey.CardOriginDetails = $root.lookupType('squareup.paymentreporter.service.GroupingKey.CardOriginDetails');
fixType(GroupingKey.CardOriginDetails);
Builder.createAndAttachToType(GroupingKey.CardOriginDetails);
/**
 * SOURCE CardOrigin @ squareup/paymentreporter/service.proto at 666:3
 */
GroupingKey.CardOrigin = $root.lookupEnum('squareup.paymentreporter.service.GroupingKey.CardOrigin').values;
/**
 * SOURCE CardBrand @ squareup/paymentreporter/service.proto at 672:3
 */
GroupingKey.CardBrand = $root.lookupEnum('squareup.paymentreporter.service.GroupingKey.CardBrand').values;
/**
 * Contains endpoints that are directly callable by a merchant from their browser via Tracon
 * (and which therefore need robust auth).
 *
 * SOURCE PaymentReporterExternalEndpointsService @ squareup/paymentreporter/service.proto at 28:1
 */
export const PaymentReporterExternalEndpointsService = $root.lookupService('squareup.paymentreporter.service.PaymentReporterExternalEndpointsService');
/**
 * Contains endpoints that are directly callable by a merchant from their browser via Tracon
 * (and which therefore need robust auth).
 *
 * SOURCE PaymentMethodsExternalEndpointsService @ squareup/paymentreporter/service.proto at 120:1
 */
export const PaymentMethodsExternalEndpointsService = $root.lookupService('squareup.paymentreporter.service.PaymentMethodsExternalEndpointsService');